import { Box, Stack, Tooltip, Typography, IconButton } from '@mui/material'
import React, { useState } from 'react'
import { Colors } from '../../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents'
import { useHistory, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

export default function StockEditLogHistory() {
    const location = useLocation();
    const EditedData = location?.state?.EditedData;
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);

    const tableView = () => {
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText />
                </Box>
            )
        }
        const columns = [
            {
                field: 'created_date', headerName: "Date & Time", flex: 0.111, headerAlign: 'center', align: 'center',
                renderCell: (params) => (<Box component={'div'}>{params?.row?.created_date ? params?.row?.created_date : '-'}</Box>)
            },
            {
                field: 'drug_name', headerName: "Drug Name", flex: 0.111,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.drug_name?.length > 25 ? <Tooltip placement='top' title={params?.row?.drug_name} arrow><div>{params?.row?.drug_name?.slice(0, 25) + '...'}</div></Tooltip> :
                        params?.row?.drug_name ? params?.row?.drug_name : '-'}
                </Box>)
            },
            {
                field: 'field_name', headerName: "Field Changed", flex: 0.111,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.field_name?.length > 25 ? <Tooltip placement='top' title={params?.row?.field_name} arrow><div>{params?.row?.field_name?.slice(0, 25) + '...'}</div></Tooltip> :
                        params?.row?.field_name ? params?.row?.field_name : '-'}
                </Box>)
            },
            {
                field: 'old_value', headerName: "Old Value", flex: 0.111,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.old_value?.length > 25 ? <Tooltip placement='top' title={params?.row?.old_value} arrow><div>{params?.row?.old_value?.slice(0, 25) + '...'}</div></Tooltip> :
                        params?.row?.old_value ? params?.row?.old_value : '-'}
                </Box>)
            },
            {
                field: 'new_value', headerName: "New value", flex: 0.111,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.new_value?.length > 25 ? <Tooltip placement='top' title={params?.row?.new_value} arrow><div>{params?.row?.new_value?.slice(0, 25) + '...'}</div></Tooltip> :
                        params?.row?.new_value ? params?.row?.new_value : '-'}
                </Box>)
            },
            {
                field: 'reason', headerName: "Reason", flex: 0.111,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.reason?.length > 25 ? <Tooltip placement='top' title={params?.row?.reason} arrow><div>{params?.row?.reason?.slice(0, 25) + '...'}</div></Tooltip> :
                        params?.row?.reason ? params?.row?.reason : '-'}
                </Box>)
            },
        ]

        return (
            <Box sx={{ height: '60vh', marginTop: '.5vw' }}>
                <DataGrid
                    rows={EditedData?.updated_fields}
                    columns={columns}
                    getRowId={(row) => row['field_name']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                />
            </Box>
        )
    }

    const prevent = () => {
        history.push("/PharmacyReports/StockEditLogReport");
    };

    return (
        <Box component={'div'} sx={{ height: '85vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => prevent()}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Back To Stock Edit Log'}</Typography>
            </Box>

            <Box component={'div'} sx={{ height: '14vh', width: '93vw', backgroundColor: 'white', marginTop: "1vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Purchase Inward Details'}</Typography>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                    <div>
                        <Typography id="eMed_PharmaVendor_headTxt">{'PI Date'}</Typography>
                        <Typography id="eMed_PharmaVendor_Txt">{EditedData?.pi_date || '-'}</Typography>
                    </div>
                    <div style={{ marginLeft: "2vw" }}>
                        <Typography id="eMed_PharmaVendor_headTxt">{'PI Number'}</Typography>
                        <Typography id="eMed_PharmaVendor_Txt">{EditedData?.po_number || '-'}</Typography>
                    </div>
                    <div style={{ marginLeft: "2vw" }}>
                        <Typography id="eMed_PharmaVendor_headTxt">{'Vendor Name'}</Typography>
                        <Typography id="eMed_PharmaVendor_Txt">
                            {EditedData?.vendor_name?.length > 30 ? <Tooltip placement='top' title={EditedData?.vendor_name} arrow><div>{EditedData?.vendor_name?.slice(0, 30) + '...'}</div></Tooltip> :
                                EditedData?.vendor_name ? EditedData?.vendor_name : '-'}
                        </Typography>
                    </div>
                    <div style={{ marginLeft: "2vw" }}>
                        <Typography id="eMed_PharmaVendor_headTxt">{'Bill Number'}</Typography>
                        <Typography id="eMed_PharmaVendor_Txt">
                            {EditedData?.bill_no?.length > 15 ? <Tooltip placement='top' title={EditedData?.bill_no} arrow><div>{EditedData?.bill_no?.slice(0, 15) + '...'}</div></Tooltip> :
                                EditedData?.bill_no ? EditedData?.bill_no : '-'}
                        </Typography>
                    </div>
                    <div style={{ marginLeft: "2vw" }}>
                        <Typography id="eMed_PharmaVendor_headTxt">{'Bill Date'}</Typography>
                        <Typography id="eMed_PharmaVendor_Txt">{EditedData?.bill_date || '-'}</Typography>
                    </div>
                    <div style={{ marginLeft: "2vw" }}>
                        <Typography id="eMed_PharmaVendor_headTxt">{'Edited By'}</Typography>
                        <Typography id="eMed_PharmaVendor_Txt">{EditedData?.created_by || '-'}</Typography>
                    </div>
                </Box>
            </Box>

            <Box component={'div'} sx={{ height: '60vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
        </Box>
    )
}